import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from '../../service/main.service';
import { DashboardService } from '../../service/dashboard.service'
import { session } from '../../../../environments/environment.session'
import { ComplaintsService } from '../../service/complaints.service'
import { SpinnerService } from '../../../shared/spinner.service'
import Swal from 'sweetalert2';
import { PdfGeneratorService } from '../../service/pdf-generator.service';
@Component({
  selector: 'app-total-greviance',
  templateUrl: './total-greviance.component.html',
  styleUrls: ['./total-greviance.component.css']
})
export class TotalGrevianceComponent implements AfterViewInit {
 @ViewChild(MatPaginator) paginator!: MatPaginator;
  myNumber = 1;
  displayedColumns: string[] = ['id', 'ticket_id', 'dateTime', 'zone','days_open','status', 'action'];

  dataSource = [

  ];

  complaints = new MatTableDataSource(this.dataSource);
  constructor(private pdfService: PdfGeneratorService,private routes: ActivatedRoute,private dashboardService: DashboardService, private cs: ComplaintsService, private router: Router, public mainService: MainService, private tspinner: SpinnerService) { }
  erpUser: any
  total_complaints: number = 0
  pending_count: number = 0
  resolved_count: number = 0
  total_escalated: number = 0
  async ngOnInit() {

    this.erpUser = JSON.parse(atob(session.erpUser))
    this.complaints.filterPredicate = (data, filter: string) => {
      const dataStr = Object.values(data).join('').toLowerCase();
      return dataStr.includes(filter);
    }
    this.getcomplaintsDtl()
    this.getComplaints()





  }
  
onDownloadPDF(element: any) {
    const b_acct_id = this.erpUser.b_acct_id;
    this.pdfService.generateComplaintPDF(b_acct_id, element.com_id);
  }

  async getcomplaintsDtl() {
    let obj = {
      b_acct_id: this.erpUser.b_acct_id,user_id: this.erpUser.user_id,
    }
    let resp = await this.dashboardService.getallComplaints(JSON.stringify(obj));
  
    if (resp['error'] == false) {
      console.log(resp['data'])
      this.total_complaints = resp['data']['total_complaints']
      this.pending_count = resp['data']['pending_complaints']
      this.resolved_count = resp['data']['total_resolved']
      this.total_escalated = resp['data']['total_escalated']

    } else {

    }
  }


  department = {}
  async getComplaints() {

    let obj = { b_acct_id: this.erpUser.b_acct_id,user_id:this.erpUser.le_id };
    this.tspinner.show('', '')
    let resp = await this.cs.getComplaints(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.tspinner.hide()
      resp.data.map((complaint: any) => {
        try {
          const deptArray = JSON.parse(complaint.dept || '[]');
          complaint.departments = deptArray.map((item: any) => Object.values(item));
        } catch (err) {
          complaint.departments = [];
        }
        return complaint;
      });
      this.complaints = new MatTableDataSource(resp['data'])
      this.complaints.paginator = this.paginator;
      return
    } else {
      this.tspinner.hide()
      Swal.fire('Opps !!', resp['data'], 'error')
      return
    }

  }
  applyFilter(filterValue: string) {
    this.complaints.filter = filterValue.trim().toLowerCase();
  }
  route(element: any) {
    this.router.navigate(['/sdp/officer/update-complaints'], {
      state: { data: element }
    });
  }

  route1(element: any) {
     this.router.navigate(['sdp/complaints/preview'],{
      state: { data: element ,fromPage : this.router.url}
    });
  }
  ngAfterViewInit(): void {
    this.mainService.dataSource = this.complaints
    // this.complaints.paginator = this.paginator;
  }
  // updateItem(element: any) {
  // console.log('Updating item:', element);
  // this.router.navigate(['/cfc/administration/verifier/complaints-details']);
  // }

}
